import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';

/* ═══════════════════════════════════════════
   SERVICE DATA — all 4 categories
   ═══════════════════════════════════════════ */
const SERVICES = {
  'website-uri': {
    icon: '🏰',
    title: 'Website-uri',
    tagline: 'De la landing page la e-commerce. Fiecare site e o fortăreață digitală.',
    accent: '#50fa7b',
    accentAlt: '#8be9fd',
    heroQuote: 'Un website bun e ca un castel — impresionant din exterior, funcțional pe interior.',
    offerings: [
      { name: 'Landing Pages', desc: 'O singură pagină, impact maxim. Conversii garantate.', price: 'de la 1.000 RON', icon: '🎯' },
      { name: 'Site Prezentare Multi-pagină', desc: 'Despre, Servicii, Portofoliu, Contact — totul profesional.', price: 'de la 1.300 RON', icon: '📄' },
      { name: 'Magazine Online', desc: 'E-commerce complet: coș, plăți, stocuri, livrare.', price: 'de la 3.000 RON', icon: '🛒' },
      { name: 'Bloguri & Platforme', desc: 'Platforme de conținut cu CMS pentru gestionare ușoară.', price: 'de la 600 RON', icon: '📝' },
    ],
    demos: [
      { title: 'Restaurant "La Conac"', type: 'Restaurant', img: '🍽️', desc: 'Meniu interactiv, rezervări online, galerie foto cu ambientul.' },
      { title: 'Salon Beauty "Iris"', type: 'Beauty', img: '💅', desc: 'Programări online, portofoliu de lucrări, prețuri servicii.' },
      { title: 'Magazin Local "Artisan"', type: 'E-commerce', img: '🛍️', desc: 'Catalog produse, coș de cumpărături, plăți cu card.' },
      { title: 'Cabinet Medical "Dr. Radu"', type: 'Medical', img: '🏥', desc: 'Programări, istoric pacienți, informații tratamente.' },
      { title: 'Pensiune "Casa din Bran"', type: 'Turism', img: '🏔️', desc: 'Galerie camere, booking, atracții zonale, prețuri sezon.' },
      { title: 'Atelier Auto "ProFix"', type: 'Auto', img: '🔧', desc: 'Servicii oferite, programări service, estimări prețuri.' },
    ],
    tech: ['HTML5 / CSS3', 'React / Next.js', 'WordPress (la cerere)', 'SSL gratuit', 'Responsive 100%', 'SEO optimizat'],
    process: [
      { step: 1, title: 'Descrii afacerea', desc: 'Completezi formularul cu detalii despre afacerea ta.' },
      { step: 2, title: 'Primești 3 demo-uri', desc: 'AI-ul nostru generează 3 variante în 30 de secunde.' },
      { step: 3, title: 'Alegi & personalizezi', desc: 'Selectezi varianta preferată, o ajustăm împreună.' },
      { step: 4, title: 'Lansare!', desc: 'Site-ul tău e live în 2-4 săptămâni.' },
    ],
  },
  'aplicatii-web': {
    icon: '⚡',
    title: 'Aplicații Web',
    tagline: 'React, Django, Flask — stiva completă, putere completă.',
    accent: '#ff79c6',
    accentAlt: '#bd93f9',
    heroQuote: 'Aplicațiile noastre nu sunt simple pagini — sunt sisteme care transformă afaceri.',
    offerings: [
      { name: 'Aplicații Full-Stack', desc: 'Django + React: de la bază de date la interfață.', price: 'de la 3000 RON', icon: '🚀' },
      { name: 'Dashboards & Admin', desc: 'Panouri de control cu grafice, rapoarte, statistici live.', price: 'de la 2000 RON', icon: '📊' },
      { name: 'Sisteme CRM / ERP', desc: 'Management clienți, facturare, inventar, fluxuri.', price: 'de la 5000 RON', icon: '🗂️' },
      { name: 'AI-Powered Tools', desc: 'Chatboți, generatoare de conținut, automatizări inteligente.', price: 'de la 2500 RON', icon: '🤖' },
    ],
    demos: [
      { title: 'Sistem Management IT', type: 'Enterprise', img: '🖥️', desc: 'Fișe de intervenție, inventar hardware, rapoarte PDF auto.' },
      { title: 'Call Center AI', type: 'Automatizare', img: '📞', desc: 'Apeluri outbound automate cu voce AI, detecție DA/NU.' },
      { title: 'Platformă E-learning', type: 'Educație', img: '🎓', desc: 'Cursuri video, quiz-uri, certificări, progres studenti.' },
      { title: 'Generator Demo-uri', type: 'AI Tool', img: '🧄', desc: 'Generare automată de 3 variante website cu AI.' },
      { title: 'Tracker Inventar', type: 'Business', img: '📦', desc: 'Scanare cod bare, alertă stoc minim, rapoarte consum.' },
    ],
    tech: ['Django / Flask', 'React / TypeScript', 'PostgreSQL', 'Redis / Celery', 'Docker', 'REST API / GraphQL'],
    process: [
      { step: 1, title: 'Consultanță', desc: 'Analizăm nevoia și desenăm arhitectura.' },
      { step: 2, title: 'Prototip', desc: 'UI/UX wireframes + validare cu tine.' },
      { step: 3, title: 'Dezvoltare', desc: 'Sprint-uri de 2 săptămâni cu demo-uri live.' },
      { step: 4, title: 'Deploy & Training', desc: 'Lansare pe server + instruire echipă.' },
    ],
  },
  'design-ui-ux': {
    icon: '🎨',
    title: 'Design UI/UX',
    tagline: 'Interfețe care captivează. Dark mode? Întotdeauna.',
    accent: '#bd93f9',
    accentAlt: '#f1fa8c',
    heroQuote: 'Design-ul bun e invizibil. Design-ul extraordinar te face să rămâi.',
    offerings: [
      { name: 'Design Responsive', desc: 'Mobile-first, perfect pe orice ecran.', price: 'de la 400 RON', icon: '📱' },
      { name: 'Redesign Site Existent', desc: 'Transformăm site-ul vechi într-o experiență modernă.', price: 'de la 600 RON', icon: '✨' },
      { name: 'Prototipare Figma', desc: 'Wireframes interactive, testabile, înainte de cod.', price: 'de la 300 RON', icon: '🎨' },
      { name: 'Branding Digital', desc: 'Logo, paletă culori, tipografie, ghid brand complet.', price: 'de la 800 RON', icon: '🎭' },
    ],
    demos: [
      { title: 'DraculaDev Theme', type: 'Dark Mode', img: '🧛', desc: 'Tema noastră proprie: gothic, dark, cu accente neon.' },
      { title: 'Dashboard Analytics', type: 'UI Design', img: '📈', desc: 'Grafice animate, culori contrastante, layout intuitiv.' },
      { title: 'App Mobile UI', type: 'Mobile', img: '📲', desc: 'Design pentru app de comenzi, cu animații fluide.' },
      { title: 'Landing Page Fitness', type: 'Web Design', img: '💪', desc: 'Layout dinamic, CTA-uri puternice, galerie motivațională.' },
    ],
    tech: ['Figma / Adobe XD', 'CSS Animations', 'Framer Motion', 'Tailwind CSS', 'Dark Mode Specialist', 'Micro-interacțiuni'],
    process: [
      { step: 1, title: 'Research', desc: 'Analizăm competiția și publicul țintă.' },
      { step: 2, title: 'Wireframes', desc: 'Structura paginilor, fără culori.' },
      { step: 3, title: 'Design Final', desc: 'Culori, fonturi, imagini, animații.' },
      { step: 4, title: 'Implementare', desc: 'Transformăm design-ul în cod funcțional.' },
    ],
  },
  'mentenanta': {
    icon: '🔧',
    title: 'Mentenanță',
    tagline: 'Site-ul tău nu doarme niciodată. Nici noi.',
    accent: '#f1fa8c',
    accentAlt: '#ffb86c',
    heroQuote: 'Un site fără mentenanță e ca un castel fără gardă — expus la orice.',
    offerings: [
      { name: 'Pachet Basic', desc: 'Backup-uri, update-uri, monitorizare uptime.', price: '150 RON/lună', icon: '🛡️' },
      { name: 'Pachet Business', desc: 'Basic + modificări conținut, SEO lunar, rapoarte.', price: '250 RON/lună', icon: '📋' },
      { name: 'Pachet Premium', desc: 'Business + funcționalități noi, suport prioritar 24/7.', price: '500 RON/lună', icon: '👑' },
      { name: 'Intervenție Unică', desc: 'Fix-uri urgente, migrări, rezolvare hack-uri.', price: 'de la 150 RON', icon: '🚨' },
    ],
    demos: [
      { title: 'Monitorizare 24/7', type: 'Uptime', img: '📡', desc: 'Alerte instant când site-ul pică, rezolvare în <1 oră.' },
      { title: 'Backup Automat', type: 'Securitate', img: '💾', desc: 'Backup zilnic complet, restaurare cu un click.' },
      { title: 'Speed Optimization', type: 'Performance', img: '⚡', desc: 'Audit pagini lente, optimizare imagini, caching.' },
      { title: 'Security Audit', type: 'Securitate', img: '🔐', desc: 'Scanare vulnerabilități, update dependințe, SSL.' },
    ],
    tech: ['Nginx / Apache', 'Cloudflare CDN', 'SSL/TLS', 'Git Deployment', 'Monitoring (UptimeRobot)', 'Linux Administration'],
    process: [
      { step: 1, title: 'Audit Inițial', desc: 'Analizăm starea actuală a site-ului.' },
      { step: 2, title: 'Plan Mentenanță', desc: 'Stabilim pachetul și frecvența.' },
      { step: 3, title: 'Implementare', desc: 'Configurăm backup-uri, monitoring, update-uri.' },
      { step: 4, title: 'Rapoarte Lunare', desc: 'Primești raport cu ce s-a făcut.' },
    ],
  },
};

/* ═══════════════════════════════════════════
   ANIMATED BACKGROUND — bats flying
   ═══════════════════════════════════════════ */
const BatParticles = ({ color }) => (
  <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', opacity: 0.06 }}>
    {[...Array(8)].map((_, i) => (
      <div key={i} style={{
        position: 'absolute',
        fontSize: 20 + Math.random() * 30,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animation: `floatBat ${8 + Math.random() * 12}s ease-in-out infinite`,
        animationDelay: `${-Math.random() * 10}s`,
        color: color,
      }}>🦇</div>
    ))}
  </div>
);

/* ═══════════════════════════════════════════
   MAIN SERVICE PAGE COMPONENT
   ═══════════════════════════════════════════ */
const ServicePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [hoveredDemo, setHoveredDemo] = useState(null);
  const [hoveredOffering, setHoveredOffering] = useState(null);

  const service = SERVICES[slug];

  if (!service) {
    return (
      <div style={{
        minHeight: '100vh', background: 'rgba(13,14,18,0.95)',
        display: 'flex', flexDirection: 'column',
        justifyContent: 'center', alignItems: 'center',
        fontFamily: "'Space Grotesk', sans-serif", color: '#f8f8f2',
      }}>
        <div style={{ fontSize: 80, marginBottom: 20 }}>🧛</div>
        <h1 style={{ fontSize: 32, marginBottom: 12 }}>404 — Serviciu negăsit</h1>
        <p style={{ color: '#8b90a8', marginBottom: 32 }}>Vampirul nostru nu a găsit această pagină.</p>
        <Link to="/" style={{
          padding: '12px 32px', background: '#bd93f9', borderRadius: 8,
          color: '#282a36', fontWeight: 700, textDecoration: 'none',
        }}>← Înapoi la castel</Link>
      </div>
    );
  }

  const { icon, title, tagline, accent, accentAlt, heroQuote, offerings, demos, tech, process } = service;
  const otherServices = Object.entries(SERVICES).filter(([k]) => k !== slug);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'transparent',
      color: '#f8f8f2',
      fontFamily: "'Space Grotesk', 'Segoe UI', sans-serif",
      overflowX: 'hidden',
    }}>

      {/* Dark overlay — more opaque for readability */}
      <div style={{
        position: 'fixed', inset: 0, zIndex: 0,
        background: 'rgba(13,14,18,0.92)',
        pointerEvents: 'none',
      }} />

      {/* ═══ GLOBAL STYLES ═══ */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Crimson+Pro:ital,wght@0,400;0,600;1,400&family=JetBrains+Mono:wght@400;500&display=swap');

        @keyframes floatBat {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          25% { transform: translate(30px, -20px) rotate(5deg); }
          50% { transform: translate(-20px, 15px) rotate(-3deg); }
          75% { transform: translate(15px, -30px) rotate(4deg); }
        }
        @keyframes pulseGlow {
          0%, 100% { box-shadow: 0 0 20px ${accent}15; }
          50% { box-shadow: 0 0 40px ${accent}30; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>

      {/* ═══ HERO SECTION ═══ */}
      <section style={{
        position: 'relative',
        padding: '120px 24px 80px',
        background: `radial-gradient(ellipse at 30% 20%, ${accent}08 0%, transparent 50%),
                     radial-gradient(ellipse at 70% 80%, ${accentAlt}06 0%, transparent 50%)`,
        borderBottom: `1px solid ${accent}15`,
        overflow: 'hidden',
        zIndex: 1,
      }}>
        <BatParticles color={accent} />

        <div style={{ maxWidth: 900, margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <Link to="/" style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            color: '#8b90a8', textDecoration: 'none', fontSize: 14,
            marginBottom: 40, fontFamily: "'JetBrains Mono', monospace",
            transition: 'color 0.2s',
          }}
          onMouseEnter={e => e.target.style.color = accent}
          onMouseLeave={e => e.target.style.color = '#8b90a8'}>
            ← draculadev.com
          </Link>

          <div style={{
            display: 'inline-block', fontSize: 64, marginBottom: 20,
            animation: 'slideUp 0.6s ease-out',
          }}>{icon}</div>

          <h1 style={{
            fontSize: 'clamp(36px, 6vw, 64px)',
            fontWeight: 700, lineHeight: 1.1, marginBottom: 16,
            animation: 'slideUp 0.6s ease-out 0.1s both',
          }}>
            <span style={{ color: accent }}>//</span> {title}
          </h1>

          <p style={{
            fontSize: 'clamp(16px, 2.5vw, 22px)',
            color: '#c0c4d8',
            maxWidth: 600, lineHeight: 1.5, marginBottom: 32,
            animation: 'slideUp 0.6s ease-out 0.2s both',
          }}>{tagline}</p>

          <blockquote style={{
            borderLeft: `3px solid ${accent}40`,
            paddingLeft: 20,
            fontFamily: "'Crimson Pro', Georgia, serif",
            fontStyle: 'italic', fontSize: 18,
            color: '#8b90a8',
            maxWidth: 500,
            animation: 'slideUp 0.6s ease-out 0.3s both',
          }}>"{heroQuote}"</blockquote>
        </div>
      </section>

      {/* ═══ OFFERINGS ═══ */}
      <section style={{ padding: '80px 24px', maxWidth: 1100, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <h2 style={{
          fontSize: 28, fontWeight: 700, marginBottom: 12,
          fontFamily: "'JetBrains Mono', monospace",
        }}>
          <span style={{ color: accent }}>$</span> Ce oferim
        </h2>
        <div style={{
          height: 2, width: 60, background: `linear-gradient(90deg, ${accent}, transparent)`,
          marginBottom: 40,
        }} />

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: 20,
        }}>
          {offerings.map((offer, i) => (
            <div key={i}
              onMouseEnter={() => setHoveredOffering(i)}
              onMouseLeave={() => setHoveredOffering(null)}
              style={{
                background: hoveredOffering === i
                  ? `linear-gradient(135deg, ${accent}12, ${accentAlt}08)`
                  : 'rgba(19,20,26,0.95)',
                border: `1px solid ${hoveredOffering === i ? accent + '50' : '#2a2d3a'}`,
                borderRadius: 12, padding: '28px 24px',
                transition: 'all 0.3s ease',
                transform: hoveredOffering === i ? 'translateY(-4px)' : 'none',
                animation: `slideUp 0.5s ease-out ${0.1 * i}s both`,
                cursor: 'default',
              }}>
              <div style={{ fontSize: 32, marginBottom: 12 }}>{offer.icon}</div>
              <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8, color: '#f8f8f2' }}>
                {offer.name}
              </h3>
              <p style={{ color: '#8b90a8', fontSize: 14, lineHeight: 1.6, marginBottom: 16 }}>
                {offer.desc}
              </p>
              <span style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 13, color: accent, fontWeight: 600,
                padding: '4px 12px',
                background: `${accent}15`,
                borderRadius: 6,
              }}>{offer.price}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ═══ DEMO PORTFOLIO ═══ */}
      <section style={{
        padding: '80px 24px',
        background: `linear-gradient(180deg, transparent, ${accent}03, transparent)`,
        position: 'relative', zIndex: 1,
      }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <h2 style={{
            fontSize: 28, fontWeight: 700, marginBottom: 12,
            fontFamily: "'JetBrains Mono', monospace",
          }}>
            <span style={{ color: accent }}>{'>'}</span> Portofoliu & Demo-uri
          </h2>
          <div style={{
            height: 2, width: 60,
            background: `linear-gradient(90deg, ${accent}, transparent)`,
            marginBottom: 40,
          }} />

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: 20,
          }}>
            {demos.map((demo, i) => (
              <div key={i}
                onMouseEnter={() => setHoveredDemo(i)}
                onMouseLeave={() => setHoveredDemo(null)}
                style={{
                  position: 'relative',
                  background: 'rgba(19,20,26,0.95)',
                  borderRadius: 12, overflow: 'hidden',
                  border: `1px solid ${hoveredDemo === i ? accent + '40' : '#2a2d3a'}`,
                  transition: 'all 0.3s ease',
                  transform: hoveredDemo === i ? 'translateY(-6px)' : 'none',
                  boxShadow: hoveredDemo === i ? `0 16px 40px ${accent}15` : 'none',
                  animation: `fadeIn 0.5s ease-out ${0.08 * i}s both`,
                }}>
                <div style={{
                  height: 140,
                  background: `linear-gradient(135deg, ${accent}18, ${accentAlt}12)`,
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  fontSize: 56,
                  transition: 'transform 0.3s ease',
                  transform: hoveredDemo === i ? 'scale(1.05)' : 'scale(1)',
                }}>
                  {demo.img}
                </div>

                <div style={{
                  position: 'absolute', top: 12, right: 12,
                  padding: '3px 10px', borderRadius: 6,
                  background: `${accent}25`, color: accent,
                  fontSize: 11, fontWeight: 600,
                  fontFamily: "'JetBrains Mono', monospace",
                  backdropFilter: 'blur(8px)',
                }}>{demo.type}</div>

                <div style={{ padding: '20px 20px 24px' }}>
                  <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#f8f8f2' }}>
                    {demo.title}
                  </h3>
                  <p style={{ color: '#8b90a8', fontSize: 13, lineHeight: 1.5 }}>
                    {demo.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ PROCESS TIMELINE ═══ */}
      <section style={{ padding: '80px 24px', maxWidth: 900, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <h2 style={{
          fontSize: 28, fontWeight: 700, marginBottom: 12,
          fontFamily: "'JetBrains Mono', monospace",
        }}>
          <span style={{ color: accent }}>~</span> Cum lucrăm
        </h2>
        <div style={{
          height: 2, width: 60,
          background: `linear-gradient(90deg, ${accent}, transparent)`,
          marginBottom: 48,
        }} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {process.map((p, i) => (
            <div key={i} style={{
              display: 'flex', gap: 24, alignItems: 'flex-start',
              animation: `slideUp 0.5s ease-out ${0.15 * i}s both`,
            }}>
              <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                flexShrink: 0,
              }}>
                <div style={{
                  width: 40, height: 40, borderRadius: '50%',
                  background: `${accent}18`,
                  border: `2px solid ${accent}50`,
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 14, fontWeight: 700, color: accent,
                }}>
                  {p.step}
                </div>
                {i < process.length - 1 && (
                  <div style={{
                    width: 2, height: 48,
                    background: `linear-gradient(180deg, ${accent}30, transparent)`,
                  }} />
                )}
              </div>

              <div style={{ paddingBottom: i < process.length - 1 ? 24 : 0 }}>
                <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 4, color: '#f8f8f2' }}>
                  {p.title}
                </h3>
                <p style={{ color: '#8b90a8', fontSize: 14, lineHeight: 1.5 }}>
                  {p.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ═══ TECH STACK ═══ */}
      <section style={{
        padding: '60px 24px',
        background: `linear-gradient(180deg, transparent, ${accent}04, transparent)`,
        position: 'relative', zIndex: 1,
      }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{
            fontSize: 22, fontWeight: 700, marginBottom: 24,
            fontFamily: "'JetBrains Mono', monospace",
          }}>
            <span style={{ color: accent }}>{'#'}</span> Tehnologii folosite
          </h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
            {tech.map((t, i) => (
              <span key={i} style={{
                padding: '8px 16px',
                background: 'rgba(22,24,30,0.95)',
                border: '1px solid #2a2d3a',
                borderRadius: 8, fontSize: 13,
                fontFamily: "'JetBrains Mono', monospace",
                color: '#b0b4c8',
                animation: `fadeIn 0.4s ease-out ${0.05 * i}s both`,
              }}>{t}</span>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ CTA SECTION ═══ */}
      <section style={{ padding: '80px 24px', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <div style={{
          maxWidth: 600, margin: '0 auto', padding: '48px 32px',
          background: `linear-gradient(135deg, ${accent}0a, ${accentAlt}06)`,
          border: `1px solid ${accent}25`,
          borderRadius: 20,
          animation: 'pulseGlow 4s ease-in-out infinite',
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🧄</div>
          <h2 style={{
            fontSize: 26, fontWeight: 700, marginBottom: 12,
            fontFamily: "'Space Grotesk', sans-serif",
          }}>
            Pregătit să începem?
          </h2>
          <p style={{ color: '#8b90a8', fontSize: 15, marginBottom: 28, lineHeight: 1.6 }}>
            Generăm 3 demo-uri gratuit în 30 de secunde.<br/>
            Fără obligații, fără costuri ascunse.
          </p>
          <button
            onClick={() => navigate('/?demo=true')}
            style={{
              padding: '14px 40px',
              background: `linear-gradient(135deg, ${accent}, ${accentAlt})`,
              border: 'none', borderRadius: 10,
              color: '#0d0e12', fontWeight: 700, fontSize: 16,
              cursor: 'pointer',
              fontFamily: "'Space Grotesk', sans-serif",
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={e => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = `0 8px 30px ${accent}40`;
            }}
            onMouseLeave={e => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = 'none';
            }}
          >
            🧛 Generează Demo Gratuit →
          </button>
        </div>
      </section>

      {/* ═══ OTHER SERVICES ═══ */}
      <section style={{
        padding: '60px 24px 80px',
        borderTop: '1px solid #2a2d3a',
        position: 'relative', zIndex: 1,
      }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h3 style={{
            fontSize: 16, color: '#b0b4c8', marginBottom: 20,
            fontFamily: "'JetBrains Mono', monospace",
          }}>
            Alte servicii →
          </h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
            {otherServices.map(([key, s]) => (
              <Link key={key} to={`/servicii/${key}`} style={{
                padding: '10px 20px',
                background: 'rgba(19,20,26,0.95)',
                border: `1px solid ${s.accent}30`,
                borderRadius: 10,
                color: '#e0e2f0',
                textDecoration: 'none',
                fontSize: 14, fontWeight: 500,
                transition: 'all 0.2s',
                display: 'flex', alignItems: 'center', gap: 8,
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = s.accent;
                e.currentTarget.style.background = `${s.accent}15`;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = `${s.accent}30`;
                e.currentTarget.style.background = 'rgba(19,20,26,0.95)';
              }}>
                <span>{s.icon}</span> {s.title}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ FOOTER ═══ */}
      <footer style={{
        padding: '32px 24px',
        borderTop: '1px solid #2a2d3a',
        textAlign: 'center',
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 12,
        color: '#8b90a8',
        position: 'relative', zIndex: 1,
      }}>
        © 2026 DraculaDev — Fortăreața ta digitală din Transilvania 🧛
      </footer>
    </div>
  );
};

export default ServicePage;